import React, { useMemo } from "react";
import { Typography } from "antd";
import AttendancePersonCard from "./AttendancePersonCard";
import {
	ATTENDANCE_EXCEPTION_EXTRA,
	ATTENDANCE_EXCEPTION_ROWS,
	getAttendanceExceptionGroup,
	halfDayExceptionLabel,
} from "./attendanceHelpers";

const { Text } = Typography;

const AttendanceDayExceptions = ({
	employees = [],
	date,
	title = "당일 특이사항",
	onCellClick,
}) => {
	const { rows, extraGroups } = useMemo(() => {
		if (!date) {
			return { rows: [], extraGroups: [] };
		}
		const allKeys = [
			...ATTENDANCE_EXCEPTION_ROWS.flat().map((g) => g.key),
			...ATTENDANCE_EXCEPTION_EXTRA.map((g) => g.key),
		];
		const buckets = Object.fromEntries(allKeys.map((key) => [key, []]));
		employees.forEach((employee) => {
			const group = getAttendanceExceptionGroup(employee.cells?.[date]);
			if (group && buckets[group]) {
				buckets[group].push(employee);
			}
		});
		const sortPeople = (list) =>
			list.sort((a, b) =>
				String(a.name || "").localeCompare(String(b.name || ""), "ko"),
			);

		const builtRows = ATTENDANCE_EXCEPTION_ROWS.map((pair) => {
			const cells = pair.map((group) => ({
				...group,
				employees: sortPeople([...(buckets[group.key] || [])]),
			}));
			const hasAny = cells.some((c) => c.employees.length > 0);
			return hasAny ? cells : null;
		}).filter(Boolean);

		const builtExtra = ATTENDANCE_EXCEPTION_EXTRA.map((group) => ({
			...group,
			employees: sortPeople([...(buckets[group.key] || [])]),
		})).filter((group) => group.employees.length > 0);

		return { rows: builtRows, extraGroups: builtExtra };
	}, [employees, date]);

	const hasContent = rows.length > 0 || extraGroups.length > 0;

	return (
		<section className="attendance-exceptions">
			<div className="attendance-exceptions__title">
				{title}
				{date ? <Text type="secondary"> {date}</Text> : null}
			</div>
			{!hasContent ? (
				<Text type="secondary">특이사항이 없습니다.</Text>
			) : (
				<div className="attendance-people attendance-exceptions__board">
					{rows.map((pair) => (
						<div
							className="attendance-exceptions__row"
							key={pair.map((g) => g.key).join("-")}>
							{pair.map((group) => (
								<div
									className="attendance-people__group attendance-exceptions__slot"
									key={group.key}>
									<div className="attendance-people__label">
										{group.label}
									</div>
									<div className="attendance-people__cards attendance-exceptions__cards">
										{group.employees.map((employee) => (
											<AttendancePersonCard
												key={employee.user_id}
												employee={employee}
												cell={employee.cells?.[date]}
												onCellClick={onCellClick}
												statusLabel={
													group.key === "annual_leave"
														? halfDayExceptionLabel(
																employee.cells?.[date],
															)
														: group.label
												}
											/>
										))}
									</div>
								</div>
							))}
						</div>
					))}
					{extraGroups.map((group) => (
						<div className="attendance-people__group" key={group.key}>
							<div className="attendance-people__label">{group.label}</div>
							<div className="attendance-people__cards attendance-exceptions__cards">
								{group.employees.map((employee) => (
									<AttendancePersonCard
										key={employee.user_id}
										employee={employee}
										cell={employee.cells?.[date]}
										onCellClick={onCellClick}
										statusLabel={
											group.key === "annual_leave"
												? halfDayExceptionLabel(
														employee.cells?.[date],
													)
												: group.label
										}
									/>
								))}
							</div>
						</div>
					))}
				</div>
			)}
		</section>
	);
};

export default AttendanceDayExceptions;
